enum IdentityType {
    _INTERNAL = '_INTERNAL',
    FACEBOOK = 'FACEBOOK',
    TWITTER = 'TWITTER',
    INSTAGRAM = 'INSTAGRAM',
    EMAIL = 'EMAIL'
}

export type SocialIdentityType = IdentityType.FACEBOOK | IdentityType.TWITTER | IdentityType.INSTAGRAM;

export default IdentityType;
